<template>
  <div class="gs-sec-title">
    <img src="@/assets/images/编组 26@2x.png" class="gs-sec-icon" alt="">
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'GsSecTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.gs-sec-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0 14px;
  font-size: 20px;
  font-weight: 700;
  color: #111824;
  line-height: 24px;
}
.gs-sec-icon {
  width: 28px;
  height: 18px;
  flex-shrink: 0;
}
</style>
